<template>
  <title-container :title="this.title" icon="building">
    <entity-details :entity="entity"/>
  </title-container>
</template>

<script>
import TitleContainer from '@/components/utils/TitleContainer';
import EntityDetails from '@/components/entities/EntityDetails';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';


library.add(faBuilding);


export default {
  components: {
    TitleContainer,
    EntityDetails,
  },
  computed: {
    entity() {
      return this.$store.getters.entities.find(entity => entity.id === this.$route.params.id);
    },
    title() {
      const pendingDocs = this.entity.docs.filter(doc => doc.neededCount !== 0)
        .map(({ type }) => type);
      if (pendingDocs.length === 0) {
        return 'My APPROVED Entities';
      }
      return 'My PENDING Entities';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/entities/EntityDetailsPage.vue